export default __webpack_public_path__ + "static/media/hero-girl-kissing-dog.b2bb35e3.jpg";